import React, { Component } from "react";
import { Helmet } from "react-helmet";

class PageHelmet extends Component{
    render(){
        const {
            pageTitle,
            description,
            canonical,
            ogImage,
            structuredData,
            robots,
        } = this.props;

        const siteName = "Theo Mefford";
        const siteUrl = "https://www.theomefford.com";
        const defaultTitle = `${siteName} | AI Architect & FDE`;
        const resolvedTitle = pageTitle && pageTitle !== siteName
            ? `${pageTitle} | ${siteName}`
            : defaultTitle;

        const resolvedDescription = description || "AI Architect & FDE building enterprise AI platforms, agent orchestration, and governance-by-design.";
        const resolvedRobots = robots || "index,follow";
        const resolvedCanonical = canonical
            ? (canonical.startsWith("http") ? canonical : `${siteUrl}${canonical}`)
            : null;
        const resolvedOgImage = ogImage || "/assets/images/portfolio/headshot.jpg";
        const resolvedOgImageAbsolute = resolvedOgImage.startsWith("http")
            ? resolvedOgImage
            : `${siteUrl}${resolvedOgImage}`;
        const resolvedStructuredData = structuredData
            ? (typeof structuredData === "string" ? structuredData : JSON.stringify(structuredData))
            : null;

        return(
            <React.Fragment>
                <Helmet>
                    <title>{resolvedTitle}</title>
                    <meta name="description" content={resolvedDescription} />
                    <meta name="robots" content={resolvedRobots} />

                    {resolvedCanonical ? <link rel="canonical" href={resolvedCanonical} /> : null}

                    <meta property="og:site_name" content={siteName} />
                    <meta property="og:title" content={resolvedTitle} />
                    <meta property="og:description" content={resolvedDescription} />
                    <meta property="og:type" content="website" />
                    {resolvedCanonical ? <meta property="og:url" content={resolvedCanonical} /> : null}
                    <meta property="og:image" content={resolvedOgImageAbsolute} />
                    <meta property="og:image:alt" content={resolvedTitle} />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={resolvedTitle} />
                    <meta name="twitter:description" content={resolvedDescription} />
                    <meta name="twitter:image" content={resolvedOgImageAbsolute} />
                    <meta name="twitter:image:alt" content={resolvedTitle} />

                    {resolvedStructuredData ? (
                        <script type="application/ld+json">
                            {resolvedStructuredData}
                        </script>
                    ) : null}
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
